import React from 'react';
import { Box, Typography, Paper } from '@material-ui/core';
import { ReportCardComponentProps } from '../schema-types';
import { filterDOMProps } from '../utils/prop-normalizer';

interface ScoringRangeItem {
  range: string;
  label: string;
  description: string;
  coachInsight?: string;
  color: string;
  backgroundColor: string;
}

interface ScoringGuideData {
  title?: string;
  subtitle?: string;
  ranges: ScoringRangeItem[];
  additionalInfo?: string;
  format?: 'vertical' | 'horizontal';
}

export const ScoringGuideComponent: React.FC<ReportCardComponentProps> = ({
  data,
  baseData: _baseData,
  player: _player,
  playerAssessment: _playerAssessment,
  reportCardLevel: _reportCardLevel,
  context: _context,
  ...props
}) => {
  const {
    title = 'Scoring Format',
    subtitle = 'Scores are presented in one of two ways:',
    ranges = [],
    additionalInfo,
    format = 'vertical'
  }: ScoringGuideData = data || {};

  return (
    <Box mb={3} {...filterDOMProps(props)}>
      <Paper elevation={2} style={{ padding: 20, backgroundColor: '#f9f9f9', borderRadius: 12 }}>
        <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', color: '#2e7d32' }}>
          {title}
        </Typography>

        {subtitle && (
          <Typography variant="body2" gutterBottom style={{ marginBottom: 16 }}>
            {subtitle}
          </Typography>
        )}

        <Box display="flex" flexDirection={format === 'vertical' ? 'column' : 'row'}>
          {ranges.map((range, index) => (
            <Box
              key={index}
              style={{
                backgroundColor: range.backgroundColor,
                border: `2px solid ${range.color}`,
                borderRadius: 8,
                padding: 12,
                flex: format === 'horizontal' ? 1 : 'none',
                marginBottom: format === 'vertical' ? 16 : 0,
                marginRight: format === 'horizontal' ? 16 : 0
              }}
            >
              <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: range.color }}>
                {range.range}
              </Typography>
              <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: 4 }}>
                {range.label}
              </Typography>
              <Typography variant="body2" style={{ fontSize: '0.85em', lineHeight: 1.4 }}>
                {range.description}
              </Typography>
              {range.coachInsight && (
                <Box mt={1} p={1} style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', borderRadius: 4 }}>
                  <Typography variant="body2" style={{ fontSize: '0.8em', fontStyle: 'italic', color: '#555' }}>
                    💡 Coach Insight: {range.coachInsight}
                  </Typography>
                </Box>
              )}
            </Box>
          ))}
        </Box>

        {additionalInfo && (
          <Box mt={2} p={2} style={{ backgroundColor: '#e8f5e8', borderRadius: 8 }}>
            <Typography variant="body2" style={{ fontStyle: 'italic', color: '#2e7d32' }}>
              💡 {additionalInfo}
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};
